let selectedMetalRingShape = "round";
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function () {
    if (event.target.id === "select-diamond-button") {
      redirectToDiamondSelection();
    }
  });

  const shapeItems = document.querySelectorAll('.shape-click');
  shapeItems.forEach(item => {
    item.addEventListener('click', () => {
      const selectedShape = item.dataset.shape;
      selectShape(selectedShape);
      fetchCorrectVariant();
    });
  });

  // Restore engraving and birthstone details when returning from diamond picker
  restoreEngravingAndBirthstoneDetails();

  // Monitor for DOM updates
  const observer = new MutationObserver(() => {
    console.log("🔄 DOM mutation detected.");
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function redirectToDiamondSelection() {
  sessionStorage.clear();

  const metalSelect = document.getElementById("metal-select");
  const ringSizeSelect = document.getElementById("ring-size-select");
  const productDataElement = document.getElementById("product-data");
  const engravingTextarea = document.getElementById("engraving");
  const birthstoneCheckboxes = document.querySelectorAll('input[name="birthStones[]"]:checked');

  const productData = JSON.parse(productDataElement.textContent);

  const selectedMetal = metalSelect?.value;
  const selectedSize = ringSizeSelect?.value;
  const previewImageUrl = filteredImages?.[0]?.url || '';
  
  // Capture engraving text
  const engravingText = engravingTextarea?.value || '';
  
  // Capture selected birthstones
  const selectedBirthstones = Array.from(birthstoneCheckboxes).map(checkbox => ({
    variantId: checkbox.value,
    name: checkbox.getAttribute('data-name'),
    price: 600
  }));

  let currentUrl = window.location.href;
  let selectedCurrentRingDetails = {
    ringSize: selectedSize,
    metal: selectedMetal,
    name: productData.title,
    currentUrl: currentUrl,
    shape: selectedMetalRingShape,
    imagePreview: previewImageUrl,
    engraving: engravingText,
    birthstones: selectedBirthstones
  }
  sessionStorage.setItem("selectedCurrentRingDetails", JSON.stringify(selectedCurrentRingDetails));
  window.location.href = "/pages/diamond-picker";
}

/**
 * Programmatically select a shape
 */
function selectShape(shapeName) {
  const shapeItems = document.querySelectorAll(".shape-click");
  selectedMetalRingShape = shapeName;
  shapeItems.forEach(item => {
    const isSelected = item.dataset.shape === shapeName;
    const selectedImg = item.querySelector(".shape-img-selected");
    const unselectedImg = item.querySelector(".shape-img-unselected");

    if (isSelected) {
      selectedImg.classList.remove("hidden");
      unselectedImg.classList.add("hidden");
    } else {
      selectedImg.classList.add("hidden");
      unselectedImg.classList.remove("hidden");
    }
  });
}

/**
 * Restore engraving and birthstone details when returning from diamond picker
 */
function restoreEngravingAndBirthstoneDetails() {
  const selectedCurrentRingDetailsJSON = sessionStorage.getItem("selectedCurrentRingDetails");
  
  if (selectedCurrentRingDetailsJSON) {
    try {
      const ringDetails = JSON.parse(selectedCurrentRingDetailsJSON);
      
      // Restore engraving
      if (ringDetails.engraving) {
        const engravingTextarea = document.getElementById("engraving");
        if (engravingTextarea) {
          engravingTextarea.value = ringDetails.engraving;
        }
      }
      
      // Restore birthstones
      if (ringDetails.birthstones && ringDetails.birthstones.length > 0) {
        // Wait for birthstones to be rendered before restoring selection
        setTimeout(() => {
          restoreBirthstoneSelection(ringDetails.birthstones);
        }, 500);
      }
      
    } catch (error) {
      console.error("Error restoring engraving and birthstone details:", error);
    }
  }
}

/**
 * Restore birthstone checkbox selections
 */
function restoreBirthstoneSelection(selectedBirthstones) {
  const birthstoneCheckboxes = document.querySelectorAll('input[name="birthStones[]"]');
  
  birthstoneCheckboxes.forEach(checkbox => {
    const isSelected = selectedBirthstones.some(stone => 
      stone.variantId === checkbox.value
    );
    checkbox.checked = isSelected;
  });
  
  // Update total price after restoring birthstones
  if (typeof updateTotalPrice === 'function') {
    updateTotalPrice();
  }
}